module.exports = __webpack_public_path__ + "img/zhengzhou01.0ad650f0.png";